import { useState } from 'react'
import { TableColumn } from 'react-data-table-component'
import { DEFAULT_ROWS_PER_PAGE_OPTIONS } from '@/constants/pagination'

type UsePaginationProps = {
	defaultSortBy: string
	defaultSortDirection: 'asc' | 'desc'
	rowsPerPageOptions?: number[]
}

const usePagination = <T>({
	defaultSortBy,
	defaultSortDirection,
	rowsPerPageOptions,
}: UsePaginationProps) => {
	const initialPageSize =
		rowsPerPageOptions?.[0] ?? DEFAULT_ROWS_PER_PAGE_OPTIONS[0]
	const [pageNumber, setPageNumber] = useState(1)
	const [pageSize, setPageSize] = useState(initialPageSize)
	const [sortBy, setSortBy] = useState(defaultSortBy)
	const [sortDirection, setSortDirection] = useState<'asc' | 'desc'>(
		defaultSortDirection
	)

	const handlePageChange = (pageNumber: number) => {
		setPageNumber(pageNumber)
	}

	const handleRowsPerPageChange = (
		newPageSize: number,
		pageNumber: number
	) => {
		setPageSize(newPageSize)
		setPageNumber(pageNumber)
	}

	const handleSort = (
		column: TableColumn<T>,
		direction: 'asc' | 'desc'
	) => {
		setSortBy(column?.sortField ?? defaultSortBy)
		setSortDirection(direction)
	}

	return {
		pageNumber,
		pageSize,
		sortBy,
		sortDirection,
		handleSort,
		handlePageChange,
		handleRowsPerPageChange,
	}
}

export default usePagination
